import { withStyles } from '../../tools/withStyles';
import { Component } from './Main';
import { styles } from './Main.styles';

const Main = withStyles(styles)(Component);

export { Main };
